var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("系统管理")]),
              _c("el-breadcrumb-item", [_vm._v("资源管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-table-result" },
        [
          _c("div", { staticClass: "wrap-table-info-display" }, [
            _c(
              "section",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mgr10",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("新增")]
                ),
              ],
              1
            ),
            _c("span", { staticClass: "table-info-display" }, [
              _c("span", [_vm._v("总条数：")]),
              _c("span", { staticClass: "alert-text ft16" }, [
                _vm._v(_vm._s(_vm.dataList.length)),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              attrs: {
                slot: "content",
                data: _vm.dataList,
                border: "",
                "row-key": "id",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "资源名称",
                  prop: "resourcesName",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "资源路由", prop: "url" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "上级资源",
                  prop: "pResourcesName",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.pResourcesName
                                  ? scope.row.pResourcesName
                                  : "-"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "排序编号",
                  prop: "sort",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "操作",
                  fixed: "right",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddChildren(
                                  scope.row.id,
                                  scope.row.resourcesName
                                )
                              },
                            },
                          },
                          [_vm._v("增加子级")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该资源？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "color-danger" }, [
                              _vm._v("删除"),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ResourceDialog", {
        attrs: {
          dialogVisible: _vm.resourceDialogVisible,
          id: _vm.resourceId,
          parentResource: _vm.parentResource,
        },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.resourceDialogVisible = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.resourceDialogVisible = $event
          },
          onSuccess: function ($event) {
            return _vm.loadTableData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }